<template>
  <div class="app">
    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{ getTitleName() }} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
               :label="this.$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-tooltip bottom>
              <v-btn slot="activator" @click="insertTanitimTipOpen()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down"
                    > {{ $t('Add-v2', { value: getTitleName() }) }} </span
                  >
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span>{{ $t('Limited-Authorization') }}</span>
              <span>{{$t('Add-Payment-Instrument')}}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :rows-per-page-items="[50, 100]"
        :loading="progress"
        :items="items"
        :search="search3"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.Id }}</td>
            <td class="text-xs-left">{{ props.item.Ad }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
            <td v-if="$route.params.id == 302" class="text-xs-left">{{ props.item.Tevkifat.TevkifatOran }}</td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn @click="editDialogOpen(props.item.Id)" icon small flat>
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn @click="deleteDialogOpen(props.item.Id)" icon small flat>
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDataDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ getTitleName() }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field v-model="loadData.Ad" label="Ad"></v-text-field>
          <v-textarea v-model="loadData.Aciklama" :label="$t('Description')"></v-textarea>
          <v-text-field v-if="$route.params.id == 302" v-model="loadData.Tevkifat.TevkifatOran" label="Oran"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="editDataDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="UpdateTanitimTip()">
            {{ $t('save_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="insertDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ getTitleName() }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field v-model="loadData.Ad" label="Ad"></v-text-field>
          <v-textarea v-model="loadData.Aciklama" :label="$t('Description')"></v-textarea>
          <v-text-field v-if="$route.params.id == 302" v-model="loadData.Tevkifat.TevkifatOran" label="Oran"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="insertDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="insertTanitimTip()">
            {{ $t('save_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ getTitleName() }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteTanitimTip()"> {{ $t('Delete')  }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";

export default {
  data() {
    return {
      tanitimTip : this.$route.params.id,
      editDataDialog: false,
      insertDialog: false,
      deleteDialog: false,
      deleteId: 0,
      headers:[],
      headersStandart: [
        {
          text: "İd",
          value: "ID",
          align: "left",
        },
        {
          text: this.$t("Name_label"),
          value: "Ad",
          align: "left",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
          align: "left",
        },
        {
          text: this.$t('Process'),
          value: "İslem",
          align: "right",
        },
      ],
      headersTevkifat: [
        {
          text: "İd",
          value: "ID",
          align: "left",
        },
        {
          text: this.$t("Name_label"),
          value: "Ad",
          align: "left",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
          align: "left",
        },
        {
          text: this.$t('Ratio'),
          value: "Oran",
          align: "left",
        },
        {
          text: this.$t('Process'),
          value: "İslem",
          align: "right",
        },
      ],
      loading: false,
      progress: false,
      items: [],
      search3: "",
      loadData: {
        Id: null,
        Ad: null,
        Aciklama: null,
        AcenteDepartman: null,
        Tevkifat: {
          TevkifatOran:null,
        },
      },
    };
  },
  components: {
    tool,
  },
  methods: {
    deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteId = val;
    },
    deleteTanitimTip() {
      let params = {
        TanitimTip: this.tanitimTip,
        Id: this.deleteId,
      };
      tool.http_post(this, "GenelTipTanitimDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getTanitimList();
            this.deleteDialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    insertTanitimTip() {
      let params = {
        TanitimTip: this.tanitimTip,
      };
      params = Object.assign(params, this.loadData);

      tool.http_post(this, "GenelTipTanitimInsert", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getTanitimList();
            this.insertDialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    insertTanitimTipOpen() {
      this.loadData.Id = null;
      this.loadData.Ad = null;
      this.loadData.Aciklama = null;
      this.loadData.AcenteDepartman = null;
      this.loadData.Tevkifat.TevkifatOran = null ;
      this.insertDialog = true;
    },
    UpdateTanitimTip() {
      let params = {
        TanitimTip: this.tanitimTip,
      };
      params = Object.assign(params, this.loadData);

      tool.http_post(this, "GenelTipTanitimEdit", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.editDataDialog = false;
            this.getTanitimList();
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')

          this.snackbar = true;
        }
      );
    },
    editDialogOpen(val) {
      let params = {
        ID: val,
        TanitimTip: this.tanitimTip,
      };
      tool.http_post(this, "GenelTipTanitimLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.loadData = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );

      this.editDataDialog = true;
    },
    getTanitimList() {
      this.progress = true;
      let params = {
        TanitimTip: this.tanitimTip,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.items = response.body.data;
            this.progress = false;
          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    getTitleName() {
      switch (this.$route.params.id) {
        case 8:
          return "Otel Fiyat Kodu";
        case 6:
          return this.$t('Agency-Department');
        case 302:
          return this.$t('Withholding-Code');
        default:
          break;
      }
    },
  },
  mounted() {
    switch (this.tanitimTip) {
      case 8:
        this.headers = this.headersStandart;
        break;
      case 302:
        this.headers = this.headersTevkifat;
        break;
      default:
        break;
    }
        this.getTanitimList();

  },
};
</script>

<style>
</style>